// extracted by mini-css-extract-plugin
export default {"checkout":"Basket_checkout__3awGU","cards":"Basket_cards__XTfmP"};